module.exports = __webpack_public_path__ + "static/the-language-hoax-605446de8e2e5dc48b67a4c7d907ff1b.jpg";